// Core TREZA SDK exports
export * from './compliance/treza-compliance-sdk';
export * from './compliance/zkverify-bridge';

// Version
export const VERSION = '1.0.0';